import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const ChildrenListComponent = React.lazy(() => import('./components/ChildrenList'));

const ChildrenList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <ChildrenListComponent />
      </Suspense>
    </div>
  );
}

export default ChildrenList;